"use es6";

import { number } from "../../../value/types/numbers/index";
const int = Object.assign({}, number, {
  transform: Math.round
});
export { int };